<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="8" sm12 xs24 v-for="image in 6" :key="image">
        <card>
          <card-text>
            <reflection :start-color="$dark ? 'rgba(38, 38, 38, .5)' : 'rgba(255, 255, 255, .7)'" :end-color="$dark ? 'rgba(38, 38, 38, 1) 20%' : 'rgba(255, 255, 255, 1) 20%'">
              <lazy-image :src="getImageUrl(image)" :alt="getImageUrl(image)" />
            </reflection>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageReflection',
  methods: {
    getImageUrl (index) {
      return `${this.$root.config.staticAssetsDir}/images/misc/image-0${index}.jpeg`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/reflection.vue